import ImageViewer from 'react-simple-image-viewer';
import { createKeyboardHandler, createAriaLabel } from './accessibilityHelpers';

export function createImageViewerButton({
  index,
  src,
  onImageClick,
  characterType = 'Character Design'
}) {
  return (
    <button
      onClick={() => onImageClick(index)}
      onKeyDown={createKeyboardHandler(() => onImageClick(index))}
      style={{
        border: 'none',
        background: 'none',
        padding: 0,
        cursor: 'pointer',
        display: 'block',
        width: '100%',
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'scale(1.02)';
        e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.15)';
      }}
      onFocus={(e) => {
        e.currentTarget.style.transform = 'scale(1.02)';
        e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.15)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
      }}
      onBlur={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
      }}
      aria-label={createAriaLabel('View', characterType, index)}
    >
      <img
        src={src.img}
        style={{
          width: '100%',
          height: 'auto',
          display: 'block'
        }}
        alt={`${characterType} ${index + 1} by ${src.author}`}
      />
    </button>
  );
}

export function createImageViewer({
  isOpen,
  images,
  currentIndex,
  onClose,
  disableScroll = false,
  backgroundColor = 'rgba(0,0,0,0.9)',
  closeOnClickOutside = true
}) {
  if (!isOpen) return null;

  return (
    <ImageViewer
      src={images}
      currentIndex={currentIndex}
      onClose={onClose}
      disableScroll={disableScroll}
      backgroundStyle={{
        backgroundColor,
      }}
      closeOnClickOutside={closeOnClickOutside}
    />
  );
}
